module.exports = __webpack_public_path__ + "static/media/favs.cc1bb3a5.png";